import validate from 'validate.js';

function validator(data, name) {
  let error = '';
  let errorState = false;
  switch (name) {
    case 'addressFName':
      if (validate.single(data, { presence: { allowEmpty: false } })) {
        error = 'This field is required';
        errorState = true;
      }
      return [error, errorState];

    case 'addressLName':
      if (validate.single(data, { presence: { allowEmpty: false } })) {
        error = 'This field is required';
        errorState = true;
      }
      return [error, errorState];

    case 'addressLine1':
      if (validate.single(data, { presence: { allowEmpty: false } })) {
        error = 'This field is required';
        errorState = true;
      }
      return [error, errorState];

    case 'addressCity':
      if (validate.single(data, { presence: { allowEmpty: false } })) {
        error = 'This field is required';
        errorState = true;
      }
      return [error, errorState];

    case 'addressZip':
      if (validate.single(data, { presence: { allowEmpty: false } })) {
        error = 'This field is required';
        errorState = true;
      }
      return [error, errorState];

    case 'addressCountry':
      if (validate.single(data, { presence: { allowEmpty: false } })) {
        error = 'This field is required';
        errorState = true;
      }
      return [error, errorState];

    default:
      return [error, errorState];
  }
}

export default validator;
